import claim from './claim';

export default {
  claim,
};
